$(
  // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
  (function PaymentsIFFE(global) {
    const publicAPI = {};

    const _registeredProviders = {};

    const _providerInstances = {};

    let _terminals = {};

    let _gateways = {};

    if (_.isUndefined(window.merchantos)) {
      // @ts-expect-error ts-migrate(2740) FIXME: Type '{}' is missing the following properties from... Remove this comment to see the full error message
      global.merchantos = {};
    }

    // -------------------------PUBLIC METHODS --------------------------//

    /**
     * Displays the list of available provider types
     *
     * @returns {Array} Available provider types
     */
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'availableProviders' does not exist on ty... Remove this comment to see the full error message
    publicAPI.availableProviders = function getAvailableProviders() {
      return Object.keys(_registeredProviders);
    };

    /**
     * Registers a provider type so that it can be used
     *
     * @param type {String} The type of provider
     * @param constructor {Function} The constructor for that provider type
     */
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'registerProvider' does not exist on type... Remove this comment to see the full error message
    publicAPI.registerProvider = function registerProviderFunc(
      type: TSFixMe,
      constructor: TSFixMe
    ) {
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      _registeredProviders[type] = constructor;
    };

    /**
     * Retrieves the constructor for a given provider type; this is used
     * internally for inheritance of the BaseProvider
     *
     * @param type {String} The provider type
     * @returns {Function} The constructor for the appropriate provider type
     */
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'getConstructor' does not exist on type '... Remove this comment to see the full error message
    publicAPI.getConstructor = function getProviderConstructor(type: TSFixMe) {
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      return _registeredProviders[type];
    };

    /**
     * Creates a new instance of a payment provider with an arbitrary number of
     * arguments, then stores it to the ProviderInstances object for later use
     *
     * @param type {String} The type of payment provider to create
     * @param name {String} The unique name of the provider (based on terminal/gateway name)
     * @param shopID {Number} The shop ID of the provider
     *
     * @returns An instance of a payment provider
     */
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'addProvider' does not exist on type '{}'... Remove this comment to see the full error message
    publicAPI.addProvider = function addPaymentProvider(
      type: TSFixMe,
      name: TSFixMe,
      shopID: TSFixMe
    ) {
      let provider;
      // eslint-disable-next-line prefer-rest-params
      const args = Array.prototype.slice.call(arguments, 3);

      // Check that the provider we want to use actually exists
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'availableProviders' does not exist on ty... Remove this comment to see the full error message
      if (this.availableProviders().indexOf(type) !== -1) {
        // If there are no additional arguments, we can call new normally
        if (args.length === 0) {
          // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
          provider = new _registeredProviders[type]();
        } else {
          // If there are extra arguments, we need to do some additional
          // setup to apply them
          // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
          provider = _createProviderWithArgs(_registeredProviders[type], args);
        }
      } else {
        throw new Error("That provider type doesn't exist");
      }

      // Store the provider for later access
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      if (!_providerInstances[shopID]) {
        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        _providerInstances[shopID] = {};
      }
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      _providerInstances[shopID][name] = provider;

      return provider;
    };

    /**
     * Remove an instance of a payment provider.
     *
     * @param name {String} The unique name of the provider (based on terminal/gateway name)
     * @param shopID {Number} The shop ID of the provider
     */
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'removeProvider' does not exist on type '... Remove this comment to see the full error message
    publicAPI.removeProvider = function removePaymentProvider(name: TSFixMe, shopID: TSFixMe) {
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      if (_providerInstances[shopID] && _providerInstances[shopID][name]) {
        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        delete _providerInstances[shopID][name];
      }
    };

    /**
     * Retrieves a payment provider instance based on the unique name provided
     * on creation of that instance
     *
     * @param name {String} The unique name
     * @param shopID {Number} The shop ID of the provider
     * @returns An instance of a payment provider
     */
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'getProvider' does not exist on type '{}'... Remove this comment to see the full error message
    publicAPI.getProvider = function getProviderFunc(name: TSFixMe, shopID: TSFixMe) {
      let provider;

      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      if (_providerInstances[shopID] && _providerInstances[shopID][name]) {
        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        provider = _providerInstances[shopID][name];
      }

      return provider;
    };

    /**
     * Retrieves the details for a specific EMV terminal based on its name;
     * this function is asynchronous
     *”
     * @param name {String} The terminal's unique name
     * @param shopID {Number} The terminal's shop ID
     * @returns Promise
     */
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'getTerminal' does not exist on type '{}'... Remove this comment to see the full error message
    publicAPI.getTerminal = function getTerminalByName(name: TSFixMe, shopID: TSFixMe) {
      const deferred = $.Deferred();
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'getAllTerminals' does not exist on type ... Remove this comment to see the full error message
      this.getAllTerminals().done(function findTerminal() {
        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        if (_terminals[shopID][name]) {
          // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
          deferred.resolve(_terminals[shopID][name]);
        } else {
          deferred.reject();
        }
      });

      return deferred.promise();
    };

    /**
     * Retrieves the terminal details from the API
     *
     * @param reload {Boolean} Optional; forces reloading of data from API
     *
     * @returns Promise
     */
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'getAllTerminals' does not exist on type ... Remove this comment to see the full error message
    publicAPI.getAllTerminals = function getTerminalsFunction(reload: TSFixMe) {
      const deferred = $.Deferred();

      if ($.isEmptyObject(_terminals) || reload) {
        const custID = window.merchantos.session.getSystemCustomerID();
        window.lsCloud
          .getJSONFromAPI(`/API/Account/${custID}/CCTerminal`)
          .done(function normalizeResponse(response) {
            let allTerminals = [];
            if (response.CCTerminal) {
              allTerminals = !Array.isArray(response.CCTerminal)
                ? [response.CCTerminal]
                : response.CCTerminal;
            }

            // first clear all prior terminals
            _terminals = {};

            allTerminals.forEach(function storeTerminal(terminal: TSFixMe) {
              // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
              if (!_terminals[terminal.shopID]) {
                // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                _terminals[terminal.shopID] = {};
              }
              // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
              _terminals[terminal.shopID][terminal.name] = terminal;
            });

            deferred.resolve(_terminals);
          })
          .fail(function failGetTerminals(response) {
            deferred.reject(response);
          });
      } else {
        deferred.resolve(_terminals);
      }

      return deferred.promise();
    };

    /**
     * Retrieves the gateway details from the API
     *
     * @param reload {Boolean} Optional; forces reloading of data from API
     * @param shopID {Number} The shop ID of the gateway
     *
     * @returns {$.Promise} Resolves with the CCGateway data
     */
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'getGateway' does not exist on type '{}'.
    publicAPI.getGateway = function getGatewayFunction(reload: TSFixMe, shopID: TSFixMe) {
      const deferred = $.Deferred();
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'getAllGateways' does not exist on type '... Remove this comment to see the full error message
      this.getAllGateways(reload).done(function findGateway() {
        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        if (_gateways[shopID]) {
          // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
          deferred.resolve(_gateways[shopID]);
        } else {
          deferred.reject();
        }
      });

      return deferred.promise();
    };

    /**
     * Retrieves all shop gateway details for an account from the API
     *
     * @param reload {Boolean} Optional; forces reloading of data from API
     * @returns {*}
     */
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'getAllGateways' does not exist on type '... Remove this comment to see the full error message
    publicAPI.getAllGateways = function getAllGatewaysFunction(reload: TSFixMe) {
      const deferred = $.Deferred();

      if ($.isEmptyObject(_gateways) || reload) {
        const custID = window.merchantos.session.getSystemCustomerID();

        window.lsCloud
          .getJSONFromAPI(`/API/Account/${custID}/Shop?load_relations=["CCGateway"]`)
          .done(function normalizeResponse(response) {
            let allShops = [];
            if (response.Shop) {
              allShops = !Array.isArray(response.Shop) ? [response.Shop] : response.Shop;
            }

            // first clear all prior terminals
            _gateways = {};

            allShops.forEach(function storeGateway(shop: TSFixMe) {
              if (shop.CCGateway) {
                // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                _gateways[shop.shopID] = shop.CCGateway;
              }
            });

            deferred.resolve(_gateways);
          })
          .fail(function failGetGateways(response) {
            deferred.reject(response);
          });
      } else {
        deferred.resolve(_gateways);
      }

      return deferred.promise();
    };

    // -------------------------PRIVATE HELPERS --------------------------//

    /**
     * Allows for the initialization of an arbitrary payment provider with an
     * unknown number of arguments
     *
     * @param constructor {Function} The constructor function for a provider
     * @param args {Array} The arguments to apply to the constructor
     * @returns An instance of a payment provider
     * @private
     */
    function _createProviderWithArgs(constructor: TSFixMe, args: TSFixMe) {
      function Temp() {
        // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        return constructor.apply(this, args);
      }
      Temp.prototype = constructor.prototype;

      // @ts-expect-error ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
      return new Temp();
    }

    // Add public functions to the merchantos object
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
    global.merchantos.payments = publicAPI;
  })(window)
);
